module.exports = __webpack_public_path__ + "static/img/36.c763703.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tic/qq/36.gif
// module id = pX/D
// module chunks = 0